import React from 'react';

import logo from "../../images/logos_citoplus_horizontal.png";
import loginbg from "../../images/--pic1.jpg";

const LoginLeftPanel = ({ data }) => {
  let content;

  if (data !== '' && data !== undefined && data.length > 0 ) {
    const randomData = data.sort(() => Math.random() - 1).slice(0, 1);
    content = (
      <div className="login-aside text-center d-flex flex-column flex-row-auto">
        <div className="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
        <div className="text-center mb-4 pt-5">
            <img src={logo} alt="" width="70%" />
          </div>
          {randomData.map((item) => (
            <div key={item.slug} className="message-item">
              <p dangerouslySetInnerHTML={{ __html: item.msg }} />
            </div>
          ))}
        </div>
      </div>
    );
  } else {
    content = (
      <div className="login-aside text-center d-flex flex-column flex-row-auto">
        <div className="d-flex flex-column-auto flex-column pt-lg-40 pt-15">
          <div className="text-center mb-4 pt-5">
            <img src={logo} alt="" width="80%" />
          </div>
          <h3 className="mb-2">Bienvenido de nuevo!</h3>
        </div>
        <div className="aside-image" style={{ backgroundImage: `url(${loginbg})` }}></div>
      </div>
    );
  }

  return content;
};

export default LoginLeftPanel;
